import type { FaireProductEntity } from "../../entity_types/product";

export const p_74kn956r42: FaireProductEntity = {
  token: "p_74kn956r42",
  type: "product",
  name: "Matches in Tin - The Art of Marbling",
  brandToken: "b_u89gdyfh23",
  brandName: "Roomytown Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/b91095d7351305241bf20e223c092bb1156a29ceb5796c25a5f87db588df77f1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6bb4392066b60457af79f05e811f6d488d3e08114873348c2212f398f322a80c.jpeg",
    "https://cdn.faire.com/fastly/be651589d60c07900907c71b62c9c44441dc6cec9d00a89ceb6487a72a3ae8fb.jpeg",
  ],
  priceDollars: 8.5,
  description:
    'These The Art of Marbling Safety Matches are housed in a reusable sliding lid tin featuring richly patterned artwork inspired by antique marbled book papers from the 18th and 19th centuries. Created using traditional paper marbling techniques, the swirling design was originally formed by floating pigments on water before being carefully transferred by hand onto paper, resulting in beautifully organic patterns full of movement and colour.\n\nContaining 100 safety matches with teal-coloured tips, each tin features striker paper housed within a custom brass holder on the front, combining everyday practicality with timeless decorative design. The sliding lid construction adds a tactile vintage feel, while the reusable tin is designed to be refilled and enjoyed long after the matches are gone. Perfect for coffee tables, shelves, and mantelpieces, it also makes a thoughtful gift for lovers of vintage interiors, stationery, and craftsmanship.\n\nContains 100 safety matches. Keep away from children, heat, sparks, and open flames. Store in a dry place.\n\nSize: 12cm H x 8.5cm W x 2.5cm D | 4.72" H x 3.35" W x 0.89" D',
  tags: [],
  msrpDollars: 19,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:40:44.576Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
